//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('departmentLang', {
//        templateUrl: 'views/components/views/departmentLang/departmentLang.template.html?v=' + module.version, 
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'departmentLangService', function ($stateParams, stateService, modalService, translateService, departmentLangService) {
//            const vm = this;
//            let departmentId = $stateParams.department_id;

//            let translations = {
//            	error: '',
//            	ok: ''
//            };

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await departmentLangService.listDepartmentLang({ department_id: departmentId });
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                departmentLangService.saveObj({ records: vm.model.inputListLanguages }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            vm.$onInit = function () {
//                translate();
//                loadLanguages();
//            };
//        }]
//    });
//})();
